import { WebViewerInstance } from '@pdftron/webviewer';

export const useToolBarDefault = () => {
    const getToolBarDefault = (instance: WebViewerInstance ) => {
        const { UI } = instance;

        const zoomControls = new UI.Components.Zoom({});

        // define which you want to keep
        const toolbarsToKeep = [
            instance.UI.ToolbarGroup.ANNOTATE,
            instance.UI.ToolbarGroup.SHAPES,
            // instance.UI.ToolbarGroup.MEASURE,
        ];

        // filter out the default toolbar objects for the onces you want to keep
        const defaultToolbars = instance.UI.getRibbonGroup('default-ribbon-group').items;

        const toolbars = defaultToolbars.filter((toolbar) => {
            return toolbarsToKeep.includes((toolbar as any).dataElement);
        }) as any[];

        const ribbonGroupSmxTool = new UI.Components.RibbonGroup({
            items: toolbars,
        });

        const menuButton = new instance.UI.Components.ToggleElementButton({
            dataElement: 'menuButton',
            img: 'ic-hamburger-menu',
            title: 'component.menuOverlay',
            toggleElement: 'MainMenuFlyout',
            // @ts-expect-error ignore
            type: 'toggleButton',
        });

        const defaultHeader = instance.UI.getModularHeader('default-top-header');
        defaultHeader.setItems([menuButton, zoomControls, ribbonGroupSmxTool]);

        const toolsHeader = instance.UI.getModularHeader('tools-header');
        // toolsHeader.setItems([textToolsGroupedItems]);
        toolsHeader.setItems([...toolsHeader.getItems()]);
    };

    return {
        getToolBarDefault,
    };
};
